import React from "react";
import { List, Card } from "antd";

const Mrcard = props => {
  console.log("props dataObject---------->", props);

  let keysArr = Object.keys(props.dataObject);
  console.log("keysArr---->", keysArr);

  console.log("props.dataObject.Name", props.dataObject.ActionBtns.props);
  console.log("props.dataObject.Address.props.itemik.", props.item);

  console.log(
    "props.dataObject.Address.props.item.",
    props.dataObject.ActionBtns.props.edited
  );
  console.log("props.nameactioncard", props.dataObject.ActionBtns.props.name);

  //
  //
  return (
    <Card
      style={{ width: 300 }}
      className="mobile-only"
      onClick={() =>
        props.dataObject.ActionBtns.props.edited({
          name: props.dataObject.ActionBtns.props.name,
          item: props.dataObject.ActionBtns.props.item
        })
      }
    >
      {/* {props.dataObject.ActionBtns} */}
      {props.dataObject.Name}
      {props.dataObject.ActionBtns.props.edit}
    </Card>
  );
};

export default Mrcard;

{
  /* <Card style={{width:220}} title={props.dataObject.Name} className="mobile-only" >
      {keysArr.map(item => {
        console.log("key:", item, "---", "value:", props.dataObject[item]);
        return (
          <div style={{backgroundColor: "#f0f2f5",marginBottom:"10px", display: "flex", justifyContent:"space-between"}}>
             <div style={{ fontSize:"18px", padding:"10px"}} >{item} :</div> 
            <div style={{ padding:"10px",float: "right", overflowWrap: "breakword" }}>{props.dataObject[item]}</div>
          </div>
        );
      })}
    </Card> */
}
